"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaDocumentPdfVisionneur = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utilitaires = require("../../utils/utilitaires");

require("../../css/mfa-documentpdf.css");

var _semanticUiReact = require("semantic-ui-react");

var _utilitaires2 = require("../../utils/utilitaires.elements");

var _MfaBoutonIconeCirclaire = require("../MfaBoutonIconeCirclaire");

var _ = require("../..");

var _MfaTexte = require("../MfaTexte");

var _utilitaires3 = require("../../utils/utilitaires.date");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaDocumentPdfVisionneur = /*#__PURE__*/function (_Component) {
  _inherits(MfaDocumentPdfVisionneur, _Component);

  var _super = _createSuper(MfaDocumentPdfVisionneur);

  function MfaDocumentPdfVisionneur(props) {
    var _this;

    _classCallCheck(this, MfaDocumentPdfVisionneur);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "maxZoom", 3);

    _defineProperty(_assertThisInitialized(_this), "minZoom", 0.1);

    _defineProperty(_assertThisInitialized(_this), "referenceZoom", void 0);

    _defineProperty(_assertThisInitialized(_this), "referenceInput", void 0);

    _defineProperty(_assertThisInitialized(_this), "element", void 0);

    _this.state = {
      noPage: 1,
      zoom: 1,
      focusBoite: false,
      focusZoom: false,
      texteBoite: '1',
      texteZoom: '100%',
      confirme: false
    };
    return _this;
  }

  _createClass(MfaDocumentPdfVisionneur, [{
    key: "obtenirBoutonPagination",
    value: function obtenirBoutonPagination(nomIcone, evennementClique) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-ib bouton"
      }, /*#__PURE__*/_react.default.createElement("a", {
        onClick: evennementClique
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: nomIcone
      })));
    }
  }, {
    key: "changerPage",
    value: function changerPage(noPage) {
      if (noPage === this.state.noPage) {
        return;
      }

      var surChangementPage = this.props.surChangementPage;
      this.setState({
        noPage: noPage
      }, function () {
        return surChangementPage(noPage);
      });
    }
  }, {
    key: "nAPasDeDocumentValide",
    value: function nAPasDeDocumentValide() {
      var nombrePages = this.props.nombrePages;
      return nombrePages === 0 || isNaN(Number(nombrePages));
    }
  }, {
    key: "obtenirValeurTexte",
    value: function obtenirValeurTexte() {
      if (this.nAPasDeDocumentValide()) {
        return '--';
      }

      var _this$state = this.state,
          noPage = _this$state.noPage,
          focusBoite = _this$state.focusBoite,
          texteBoite = _this$state.texteBoite;

      if (focusBoite === true) {
        return texteBoite;
      } else if (!(0, _utilitaires.estDefini)(noPage) || noPage === 0) {
        return '';
      }

      var nombrePages = this.props.nombrePages;
      return "".concat(noPage, " / ").concat(nombrePages);
    }
  }, {
    key: "obtenirValeurZoom",
    value: function obtenirValeurZoom() {
      if (this.nAPasDeDocumentValide()) {
        return '--';
      }

      var _this$state2 = this.state,
          zoom = _this$state2.zoom,
          focusZoom = _this$state2.focusZoom,
          texteZoom = _this$state2.texteZoom;

      if (focusZoom === true) {
        return texteZoom;
      } else if (!(0, _utilitaires.estDefini)(zoom)) {
        return '';
      }

      return this.formatterZoom(zoom);
    }
  }, {
    key: "boiteChangee",
    value: function boiteChangee(evennement, _ref) {
      var value = _ref.value;
      this.setState({
        texteBoite: value
      });
    }
  }, {
    key: "boiteZoomChangee",
    value: function boiteZoomChangee(evennement, _ref2) {
      var value = _ref2.value;
      this.setState({
        texteZoom: value
      });
    }
  }, {
    key: "boiteCliquee",
    value: function boiteCliquee() {
      var _this2 = this;

      if (this.state.focusBoite) {
        return;
      }

      this.setState({
        texteBoite: this.state.noPage.toString(),
        focusBoite: true
      }, function () {
        _this2.selectionnerInput('referenceInput');
      });
    }
  }, {
    key: "boiteZoomCliquee",
    value: function boiteZoomCliquee() {
      var _this3 = this;

      if (this.state.focusZoom) {
        return;
      }

      var zoom = this.state.zoom;
      this.setState({
        texteZoom: this.formatterZoom(zoom),
        focusZoom: true
      }, function () {
        _this3.selectionnerInput('referenceZoom');
      });
    }
  }, {
    key: "selectionnerInput",
    value: function selectionnerInput(nomReference) {
      var reference = this[nomReference];

      if (!(0, _utilitaires.estDefini)(reference)) {
        return;
      }

      var inputRef = reference.inputRef;

      if (!(0, _utilitaires.estDefini)(inputRef)) {
        return;
      }

      var current = inputRef.current;

      if (!(0, _utilitaires.estDefini)(current)) {
        return;
      }

      current.select();
    }
  }, {
    key: "boitePerteFocus",
    value: function boitePerteFocus() {
      this.changementPageTexte();
    }
  }, {
    key: "boiteZoomPerteFocus",
    value: function boiteZoomPerteFocus() {
      this.changementZoomTexte();
    }
  }, {
    key: "boiteToucheAppuyee",
    value: function boiteToucheAppuyee(_ref3) {
      var charCode = _ref3.charCode;

      if (charCode === 13
      /*Enter*/
      ) {
          this.changementPageTexte(true);
        }
    }
  }, {
    key: "boiteZoomToucheAppuyee",
    value: function boiteZoomToucheAppuyee(_ref4) {
      var charCode = _ref4.charCode;

      if (charCode === 13
      /*Enter*/
      ) {
          this.changementZoomTexte(true);
        }
    }
  }, {
    key: "changementPageTexte",
    value: function changementPageTexte(focusBoite) {
      focusBoite = (0, _utilitaires.estDefini)(focusBoite) ? focusBoite : false;
      var noPageEtat = this.state.noPage;
      var surChangementPage = this.props.surChangementPage;
      var noPage = this.extraireNoPage();
      this.setState({
        noPage: noPage,
        texteBoite: noPage.toString(),
        focusBoite: focusBoite
      }, function () {
        if (noPageEtat !== noPage) {
          surChangementPage(noPage);
        }
      });
    }
  }, {
    key: "changementZoomTexte",
    value: function changementZoomTexte(focusZoom) {
      focusZoom = (0, _utilitaires.estDefini)(focusZoom) ? focusZoom : false;
      var zoomEtat = this.state.zoom;
      var surChangementZoom = this.props.surChangementZoom;
      var zoom = this.extraireZoom();
      zoom = this.obtenirZoomDansLimite(zoom);
      this.setState({
        zoom: zoom,
        texteZoom: this.formatterZoom(zoom),
        focusZoom: focusZoom
      }, function () {
        if (zoomEtat !== zoom) {
          surChangementZoom(zoom);
        }
      });
    }
  }, {
    key: "obtenirZoomDansLimite",
    value: function obtenirZoomDansLimite(zoom) {
      return Math.min(this.maxZoom, Math.max(this.minZoom, zoom));
    }
  }, {
    key: "extraireZoom",
    value: function extraireZoom() {
      var _this$state3 = this.state,
          texteZoom = _this$state3.texteZoom,
          zoom = _this$state3.zoom;
      var correspondancePourcent = (0, _utilitaires.estDefini)(texteZoom) ? texteZoom.match(/^\d+(\.\d+)?(?=(%)?$)/) : null;
      var zoomEffectif = (0, _utilitaires.estDefini)(correspondancePourcent) ? Math.round(Number(correspondancePourcent[0]) * 100) / 10000 : zoom;
      return zoomEffectif;
    }
  }, {
    key: "extraireNoPage",
    value: function extraireNoPage() {
      var _this$state4 = this.state,
          texteBoite = _this$state4.texteBoite,
          noPage = _this$state4.noPage;
      var correspondanceChiffres = (0, _utilitaires.estDefini)(texteBoite) ? texteBoite.match(/^\d+$/) : null;
      var noPageEffectif = (0, _utilitaires.estDefini)(correspondanceChiffres) ? Number(correspondanceChiffres[0]) : noPage;
      return noPageEffectif <= this.props.nombrePages ? noPageEffectif : noPage;
    }
  }, {
    key: "surFermeture",
    value: function surFermeture() {
      var surFermeture = this.props.surFermeture;
      surFermeture();
    }
  }, {
    key: "telechargement",
    value: function telechargement() {
      var surTelechargement = this.props.surTelechargement;
      surTelechargement();
    }
  }, {
    key: "affichage",
    value: function affichage() {
      var surAffichage = this.props.surAffichage;
      surAffichage();
    }
  }, {
    key: "obtenirBouton",
    value: function obtenirBouton(nomIcone, callback, doitApparaitre) {
      if (doitApparaitre === false) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_MfaBoutonIconeCirclaire.MfaBoutonIconeCirclaire, {
        nomIcone: nomIcone,
        surClique: callback
      });
    }
  }, {
    key: "renderPied",
    value: function renderPied() {
      var _this4 = this;

      var _this$props = this.props,
          confirmationMessage = _this$props.confirmationMessage,
          etiquetteBoutonConfirmation = _this$props.etiquetteBoutonConfirmation,
          etiquetteConfirmation = _this$props.etiquetteConfirmation,
          dateConfirmation = _this$props.dateConfirmation,
          renderPied = _this$props.renderPied;

      if (!(0, _utilitaires.nestPasNulOuVide)(confirmationMessage) || renderPied === false) {
        return;
      }

      var proprietesBoite = {};

      if ((0, _utilitaires.estDefini)(dateConfirmation)) {
        proprietesBoite.checked = true;
        proprietesBoite.disabled = true;
      } else {
        proprietesBoite.onChange = function (evennement, boite) {
          return _this4.setState({
            confirme: boite.checked
          });
        };
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-documentpdf-visionneur-pied"
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Checkbox, _extends({
        label: confirmationMessage
      }, proprietesBoite)), !(0, _utilitaires.estDefini)(dateConfirmation) ? /*#__PURE__*/_react.default.createElement(_.MfaBouton, {
        nePasAjuster: true,
        desactive: this.state.confirme === false,
        estPrincipal: true,
        onClick: this.confirmer.bind(this)
      }, (0, _utilitaires.estDefini)(etiquetteBoutonConfirmation) ? etiquetteBoutonConfirmation : 'Confirmer') : /*#__PURE__*/_react.default.createElement(_MfaTexte.MfaTexte, {
        nePasAjuster: true,
        lectureSeule: true,
        valeur: (0, _utilitaires3.formatterDate)(dateConfirmation),
        etiquette: (0, _utilitaires.estDefini)(etiquetteConfirmation) ? etiquetteConfirmation : 'Date confirmation'
      }));
    }
  }, {
    key: "confirmer",
    value: function confirmer() {
      var surConfirmation = this.props.surConfirmation;
      surConfirmation();
    }
  }, {
    key: "formatterZoom",
    value: function formatterZoom(zoom) {
      return "".concat((zoom * 100).arrondir(2), "%");
    }
  }, {
    key: "changerZoom",
    value: function changerZoom(out) {
      var surChangementZoom = this.props.surChangementZoom;
      var zoom = this.state.zoom;
      zoom += (out ? -1 : 1) * 0.1;
      zoom = this.obtenirZoomDansLimite(zoom);
      this.setState({
        zoom: zoom
      }, function () {
        return surChangementZoom(zoom);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props2 = this.props,
          affichable = _this$props2.affichable,
          telechargable = _this$props2.telechargable,
          estModal = _this$props2.estModal,
          fermable = _this$props2.fermable;
      var props = (0, _utilitaires.filtrerProprietesObjet)(this.props, MfaDocumentPdfVisionneur.nomProprietes);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-documentpdf-visionneur".concat(estModal === true ? ' modal' : ''),
        ref: function ref(_ref7) {
          return (0, _utilitaires.enregistrerSiDefini)(_this5, 'element', _ref7);
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-documentpdf-visionneur-entete"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-ib"
      }, this.obtenirBoutonPagination('fast backward', function () {
        return _this5.changerPage(1);
      }), this.obtenirBoutonPagination('step backward', function () {
        return _this5.changerPage(Math.max(1, _this5.state.noPage - 1));
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-ib"
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Input, {
        onKeyPress: this.boiteToucheAppuyee.bind(this),
        ref: function ref(_ref5) {
          return (0, _utilitaires.enregistrerSiDefini)(_this5, 'referenceInput', _ref5);
        },
        className: "mfa-documentpdf-pagination",
        onChange: this.boiteChangee.bind(this),
        onClick: this.boiteCliquee.bind(this),
        onBlur: this.boitePerteFocus.bind(this),
        value: this.obtenirValeurTexte()
      })), this.obtenirBoutonPagination('step forward', function () {
        return _this5.changerPage(Math.min(_this5.props.nombrePages, _this5.state.noPage + 1));
      }), this.obtenirBoutonPagination('fast forward', function () {
        return _this5.changerPage(_this5.props.nombrePages);
      }), this.obtenirBoutonPagination('zoom-out', function () {
        return _this5.changerZoom(true);
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-ib"
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Input, {
        onKeyPress: this.boiteZoomToucheAppuyee.bind(this),
        ref: function ref(_ref6) {
          return (0, _utilitaires.enregistrerSiDefini)(_this5, 'referenceZoom', _ref6);
        },
        className: "mfa-documentpdf-zoom",
        onChange: this.boiteZoomChangee.bind(this),
        onClick: this.boiteZoomCliquee.bind(this),
        onBlur: this.boiteZoomPerteFocus.bind(this),
        value: this.obtenirValeurZoom()
      })), this.obtenirBoutonPagination('zoom-in', function () {
        return _this5.changerZoom();
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "conteneur-boutons",
        style: this.props.charge === true ? null : {
          display: 'none'
        }
      }, this.obtenirBouton("file pdf", function () {
        return _this5.affichage();
      }, affichable === true), this.obtenirBouton("download", function () {
        return _this5.telechargement();
      }, telechargable === true), this.obtenirBouton("close icon", function () {
        return _this5.surFermeture();
      }, estModal === true && fermable === true))), /*#__PURE__*/_react.default.createElement("div", props, this.props.children), this.renderPied());
    }
  }]);

  return MfaDocumentPdfVisionneur;
}(_react.Component);

exports.MfaDocumentPdfVisionneur = MfaDocumentPdfVisionneur;

_defineProperty(MfaDocumentPdfVisionneur, "nomProprietes", ['affichable', 'charge', 'confirmationMessage', 'estModal', 'dateConfirmation', 'etiquetteBoutonConfirmation', 'etiquetteConfirmation', 'fermable', 'nombrePages', 'renderPied', 'selectionnable', 'surAffichage', 'surChangementZoom', 'surChangementPage', 'surConfirmation', 'surFermeture', 'surTelechargement', 'telechargable']);